<template>
<div>
    <navi selectedid="tlCompany"></navi>
    <subNavi selectedid="tlRND" lastrouter="/company/culture" nextrouter="/company/aboutus"></subNavi>
    
    <div id="Contents">
        <!-- <div id="Logo">
            <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>
            <h2 title="HOME"><a href="../index.html" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229" height="219"></a></h2>

            <siteMenu></siteMenu>
        </div> -->
        <logo selectedid="tlCompany"></logo>
        <spNavi selectedid="tlRND"></spNavi>

        <div id="Main">
            <!-- <div class="company-article">
                <h1>RND</h1>
            </div> -->
            <r-n-d_-content></r-n-d_-content>
            <share></share>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>

import Navi from "components/common/navi"
import SubNavi from "components/company/subnavi"
import Logo from "components/common/logo"
import SpNavi from "components/company/spnavi"
import Share from "components/common/share"
import WebFooter from "components/common/footer"
import RND_Content from "components/company/rnd_content"
export default {
  name: "RND",
  components: {
    Navi,
    SubNavi,
    Logo,
    SpNavi,
    Share,
    WebFooter,
    RND_Content
  },
  data() {
    return {
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/company/rnd.vue